import React from "react";
import { usePurchaseOfferModel } from "../purchaseOfferModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";


export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePurchaseOfferModel();
    const { getSelectedDictOne } = useDictModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "询价单号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "单据状态",
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.PURCHASE_APPROVAL_STATUS),
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            placeholder: ["询价日期起始", "询价日期结束"],
            rangePickerFieldName: ["offerStartTime", "offerEndTime"],
            format: "YYYY-MM-DD",
            span: 6
        },
    ]

    return (
        <>
            <YhPageHeader
                size="small"
                title="采购询价"
                triggerSearch={true}
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
                handleReset={resetSearchParam}
            />
        </>
    );
}